import React, { useEffect } from 'react';

export default function Career() {
  useEffect(() => {
    document.title = "EIT Ghana Limited - Career";
  }, []);

  return (
    <div className="pt-16 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-5 lg:px-20 py-8">
        <div className="bg-white rounded-3xl p-10 shadow-sm">
          <p className="text-blueblack font-semibold">Career details coming soon.</p>
        </div>
      </div>
    </div>
  );
}
